import { Pipe } from '@angular/core';
var groupByPipe = (function () {
    function groupByPipe() {
    }
    groupByPipe.prototype.transform = function (value, field) {
        var groupedObj = value.reduce(function (prev, cur) {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            }
            else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        return Object.keys(groupedObj).map(function (key) { return ({ key: key, value: groupedObj[key] }); });
    };
    groupByPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'groupBy',
                    pure: false
                },] },
    ];
    /** @nocollapse */
    groupByPipe.ctorParameters = function () { return []; };
    return groupByPipe;
}());
export { groupByPipe };
//# sourceMappingURL=group-by.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/angular2-multiselect-dropdown/group-by.js
// module id = 275
// module chunks = 3